// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJtaWNyb3NlcnZpY2VzbmFtZS12aWV3LnBhZ2Uuc2NzcyJ9 */`, "",{"version":3,"sources":["webpack://./src/app/_modals/microservicesname-view/microservicesname-view.page.scss"],"names":[],"mappings":";AACA,gLAAgL","sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
